import PropTypes from "prop-types";
import classNames from "classnames";
import Price from "../../Price/Price";
import classes from "./TablePriceCell.module.css";

const TablePriceCell = (props) => {
  const { className, price } = props;
  return (
    <Price
      value={price}
      suffix="جم"
      className={classNames(classes["price-cell"], className)}
      valueClassName={classes["price-cell__price"]}
      suffixClassName={classes["price-cell__currency"]}
    />
  );
};

export default TablePriceCell;

TablePriceCell.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number,
};
